import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { AUTH_LOGIN, FORGET_PASSWORD_API } from "@constants/api";
import { AlertResultApi, AlertError } from "@utils/alert";
import { fetching, FetchingEnum } from "./Fetching";

export const initialStateLanding = {
  toggleShowPasswordPanel: false,
  state: "done",
  token: null,
  status: null,
  fetchingForgetPassword: "done",
};

export const Landing = types
  .model({
    toggleShowPasswordPanel: types.boolean,
    state: types.string,
    token: types.maybeNull(types.string),
    status: types.maybeNull(types.number),
    exp: types.maybeNull(types.number),
    userId: types.maybeNull(types.number),
    fetchingForgetPassword: types.string,
    statusForgetPassword: types.maybeNull(types.number),
    errorMsg: types.maybeNull(types.string),
  })
  .actions((self) => ({
    setInitial() {
      self.toggleShowPasswordPanel = false;
      self.state = "done";
      self.status = null;
      self.userId = null;
      self.exp = null;
      sessionStorage.removeItem("kaye-store");
    },
    setToggleShowPasswordPanel(toggle: boolean) {
      self.toggleShowPasswordPanel = toggle;
    },
    actionLogin: flow(function* actionLogin(
      email: string,
      password: string,
      type: string,
      callback: () => void
    ) {
      self.state = "pending";
      self.status = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.request({
          method: "post",
          url: AUTH_LOGIN,
          data: {
            email: email,
            password: password,
            type: "parent",
          },
        });
        self.state = "done";
        self.token = result.data.token;
        const decode: any = jwt_decode(result.data.token);
        self.exp = decode.exp;
        self.userId = decode.userId;
        self.status = result.status;
        callback();
      } catch (error) {
        // ... including try/catch error handling
        if (error && error.response) {
          console.error("Failed to fetch projects", error.response);
          self.errorMsg = error.response.data.message;
          self.status = error.response.status;
          self.state = "error";
          return;
        }
        self.status = 500;
        self.errorMsg = "Internal Server Error";
        self.state = "error";
      }
    }),
    forgetPassword: flow(function* forgetPassword(email, callback: () => void) {
      self.fetchingForgetPassword = "pending";
      self.statusForgetPassword = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.request({
          method: "post",
          url: `${FORGET_PASSWORD_API}`,
          data: {
            email: email,
            type: "parent",
          },
        });
        self.fetchingForgetPassword = "done";
        self.statusForgetPassword = result.status;
        callback();
      } catch (error) {
        console.error("Failed to fetch projects", error);
        self.fetchingForgetPassword = "error";
        self.statusForgetPassword = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
    deleteToken() {
      self.token = null;
      self.status = null;
      self.userId = null;
      self.exp = null;
      sessionStorage.removeItem("kaye-store");
    },
  }));

export type RootInstance = Instance<typeof Landing>;
